// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ChargeVehicleWarningReason {
  ChargeWasNotPurchasedBefore = "CHARGE_WAS_NOT_PURCHASED_BEFORE",
  UnusedCharactersInLicensePlate = "UNUSED_CHARACTERS_IN_LICENSE_PLATE",
  IdentifiedPossibleExemption = "IDENTIFIED_POSSIBLE_EXEMPTION",
  VehicleCategoryWithoutChargeObligation = "VEHICLE_CATEGORY_WITHOUT_CHARGE_OBLIGATION",
  VehicleRegisterVerificationDisabled = "VEHICLE_REGISTER_VERIFICATION_DISABLED",
  VehicleNotFoundInVehicleRegister = "VEHICLE_NOT_FOUND_IN_VEHICLE_REGISTER",
  VehicleUnverifiedWithVehicleRegister = "VEHICLE_UNVERIFIED_WITH_VEHICLE_REGISTER",
  InvalidVehicleStatusInVehicleRegister = "INVALID_VEHICLE_STATUS_IN_VEHICLE_REGISTER",
  MissingOrInvalidVehicleFuelTypeInVehicleRegister = "MISSING_OR_INVALID_VEHICLE_FUEL_TYPE_IN_VEHICLE_REGISTER",
  MissingOrInvalidVehicleEmissionsInVehicleRegister = "MISSING_OR_INVALID_VEHICLE_EMISSIONS_IN_VEHICLE_REGISTER",
  MultipleVehiclesFoundInVehicleRegister = "MULTIPLE_VEHICLES_FOUND_IN_VEHICLE_REGISTER",
  VehicleRegisterFuelTypeBasedExemption = "VEHICLE_REGISTER_FUEL_TYPE_BASED_EXEMPTION",
}
export default ChargeVehicleWarningReason;
